<template>
  <div class="pay-container">
     <p class="text">请切换APP查看订单</p>
     <p class="btn" @click="toIosApp">前往法临APP</p>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    toIosApp () {
      window.location.href = 'LawSurround://'
    }
  },
  destroyed () {
  }
}
</script>

<style scoped lang="scss">

.pay-container{
  min-height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text{
    font-size: 14px;
    color: #333;
    margin-bottom: 33px;
  }
  .btn{
    width: 311px;
    height: 44px;
    // background: linear-gradient(180deg, #FFD984 0%, #FBB756 100%);
    background: #366EFF;
    border-radius: 22px 22px 22px 22px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    line-height: 44px;
    color: #FFFFFF;
  }

}
</style>
